export enum EventPrivacyType {
  PUBLIC = 'PUBLIC',
  PRIVATE_CODE = 'PRIVATE_CODE',
  PRIVATE_INVITE = 'PRIVATE_INVITE',
}
